

















































































import { Component, Vue, Prop } from "vue-property-decorator";
import Empty from "@/components/empty.vue";
import {
  GetPatientList,
  GetSearchDictionary,
  DelPatient,
} from "@/request/common";
import { GetIdArr } from "@/utils/base";
@Component({
  components: {
    Empty,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private filters: any = {
    current_page: 1,
    search: "",
  };
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private goFirst() {
    if (this.filters.current_page == 1) {
      return;
    }
    this.filters.current_page = 1;
    this.getList();
  }
  private delPatient() {
    this.$confirm("您是否确定删除当前患者？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelPatient(this, this.patient.id, loading).then((res: any) => {
        loading.close();
        this.$store.commit("updatePatient", {});
        this.getList();
      });
    });
  }
  private goLast() {
    const total = Math.ceil(this.data.total / this.data.limit);
    if (this.filters.current_page == total) {
      return;
    }
    this.filters.current_page = total;
    this.getList();
  }
  private goBefore() {
    if (this.filters.current_page == 1) {
      return;
    }
    this.filters.current_page -= 1;
    this.getList();
  }
  private goNext() {
    const total = Math.ceil(this.data.total / this.data.limit);
    if (this.filters.current_page == total) {
      return;
    }
    this.filters.current_page += 1;
    this.getList();
  }
  private selectPatient(item: any) {
    this.$emit('changePatient',item)
  }
  private search() {
    this.filters.current_page = 1;
    this.getList();
  }
  private getList() {
    const params: any = {
      params: {
        page: this.filters.current_page,
        search: this.filters.search,
        ordering: "-update_datetime",
        limit: 10,
      },
    };
    GetPatientList(this, params).then((res: any) => {
      this.data = res;
      if (res.total) {
        this.data.total_page = Math.ceil(res.total / res.limit);
      }
      if (!this.patient || !this.patient.id) {
        if (res.data.length > 0) {
          this.selectPatient(res.data[0]);
        }
      }
    });
  }
  private mounted() {
    this.getList();
  }
}
